/**
 * Function to determine whether there are unread items in the list
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasUnreadNotifications = (state) => state.data.some(item => item.read === false)

/**
 * Get the unread notification count
 *
 * @param  {Object} state
 * @return {Number}
 */
const unreadNotificationsCount = (state) => state.data.filter(item => item.read === false).length

export default {
    hasUnreadNotifications,
    unreadNotificationsCount
}



// WEBPACK FOOTER //
// ./src/state/modules/activity/getters.js